import { render, staticRenderFns } from "./CompactLayout.vue?vue&type=template&id=43800db4&scoped=true"
import script from "./CompactLayout.vue?vue&type=script&lang=js"
export * from "./CompactLayout.vue?vue&type=script&lang=js"
import style0 from "./CompactLayout.vue?vue&type=style&index=0&id=43800db4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43800db4",
  null
  
)

export default component.exports